import { store } from './../store'
import axios from 'axios'
import { toast } from 'react-toastify';

const baseURL = process.env.REACT_APP_BASE_URL
console.log(baseURL, "baseUrl")
const apiRequest = async ({
  method = 'get',
  url,
  payload,
  params,  // pass url search parameters as object 
  contentType = "application/json", noToken
}) => {
  const state = store.getState()?.user
  const token = noToken ? '' : state?.access_token
  

  const axiosInstance = axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": contentType,
      "Accept": "application/json",
    }
  });
  try {
    const { data } = await axiosInstance({
      method,
      url,
      data: payload,
      params
    })
    return data
  } catch (error) {
    console.error(error);
    // const err_code = error?.response?.status
    // console.log(err_code)
    // const is_403 = err_code === 403
    // if (is_403) toast.error('Unauthorized')
    // if (error?.message && !is_403) toast.error(error.message)
    throw error
  }
}

export { baseURL, apiRequest }

export const getAllCourses = async () => {
  const token = JSON.parse(window.sessionStorage.getItem('token'));
console.log(token, 'rtokn');

try {
    const response = await axios.get('http://134.209.232.168:8004/api/course/all', {
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
        }
    });
    if (response && response.status === 200 ) return response
    
} catch (error) {
    if (error.code === 'ERR_NETWORK') {
        toast.error('Please check your internet connection')
    } else {
        if (error?.response?.status === 401) {
            toast.error('Session expired')
            // console.log('Session expired')
        } 
    } 
    throw error;
}
}